/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../../src/routes/__root"
import { Route as AppRouteImport } from "./../../src/routes/_app"
import { Route as FirstRunRouteImport } from "./../../src/routes/first-run"
import { Route as SignInRouteImport } from "./../../src/routes/sign-in"
import { Route as AppIndexRouteImport } from "./../../src/routes/_app.index"
import { Route as AppGymRouteImport } from "./../../src/routes/_app.gym"
import { Route as AppSettingsRouteImport } from "./../../src/routes/_app.settings"
import { Route as AppShapeRouteImport } from "./../../src/routes/_app.shape"
import { Route as AppWishesRouteImport } from "./../../src/routes/_app.wishes"
import { Route as AppYouRouteImport } from "./../../src/routes/_app.you"
import { Route as AppHistoryIndexRouteImport } from "./../../src/routes/_app.history.index"
import { Route as AppHistoryIdRouteImport } from "./../../src/routes/_app.history.$id"
import { Route as AppMovementsMovementRouteImport } from "./../../src/routes/_app.movements.$movement"
import { Route as AppSessionIdIndexRouteImport } from "./../../src/routes/_app.session.$id.index"
import { Route as AppSessionIdDebriefRouteImport } from "./../../src/routes/_app.session.$id.debrief"
import { Route as AppSessionIdLiftRouteImport } from "./../../src/routes/_app.session.$id.lift"
import { Route as AppSessionIdStrengthRouteImport } from "./../../src/routes/_app.session.$id.strength"
import { Route as AppSessionIdTimerRouteImport } from "./../../src/routes/_app.session.$id.timer"
import { Route as AppSessionIdBlockBlockRouteImport } from "./../../src/routes/_app.session.$id.block.$block"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const FirstRunRoute = FirstRunRouteImport.update({
  id: "/first-run",
  path: "/first-run",
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AppGymRoute = AppGymRouteImport.update({
  id: "/gym",
  path: "/gym",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppShapeRoute = AppShapeRouteImport.update({
  id: "/shape",
  path: "/shape",
  getParentRoute: () => AppRoute,
} as any)
const AppWishesRoute = AppWishesRouteImport.update({
  id: "/wishes",
  path: "/wishes",
  getParentRoute: () => AppRoute,
} as any)
const AppYouRoute = AppYouRouteImport.update({
  id: "/you",
  path: "/you",
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryIndexRoute = AppHistoryIndexRouteImport.update({
  id: "/history/",
  path: "/history/",
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryIdRoute = AppHistoryIdRouteImport.update({
  id: "/history/$id",
  path: "/history/$id",
  getParentRoute: () => AppRoute,
} as any)
const AppMovementsMovementRoute = AppMovementsMovementRouteImport.update({
  id: "/movements/$movement",
  path: "/movements/$movement",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdIndexRoute = AppSessionIdIndexRouteImport.update({
  id: "/session/$id/",
  path: "/session/$id/",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdDebriefRoute = AppSessionIdDebriefRouteImport.update({
  id: "/session/$id/debrief",
  path: "/session/$id/debrief",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdLiftRoute = AppSessionIdLiftRouteImport.update({
  id: "/session/$id/lift",
  path: "/session/$id/lift",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdStrengthRoute = AppSessionIdStrengthRouteImport.update({
  id: "/session/$id/strength",
  path: "/session/$id/strength",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdTimerRoute = AppSessionIdTimerRouteImport.update({
  id: "/session/$id/timer",
  path: "/session/$id/timer",
  getParentRoute: () => AppRoute,
} as any)
const AppSessionIdBlockBlockRoute = AppSessionIdBlockBlockRouteImport.update({
  id: "/session/$id/block/$block",
  path: "/session/$id/block/$block",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/first-run": typeof FirstRunRoute
  "/sign-in": typeof SignInRoute
  "/gym": typeof AppGymRoute
  "/settings": typeof AppSettingsRoute
  "/shape": typeof AppShapeRoute
  "/wishes": typeof AppWishesRoute
  "/you": typeof AppYouRoute
  "/history/$id": typeof AppHistoryIdRoute
  "/movements/$movement": typeof AppMovementsMovementRoute
  "/history/": typeof AppHistoryIndexRoute
  "/session/$id/debrief": typeof AppSessionIdDebriefRoute
  "/session/$id/lift": typeof AppSessionIdLiftRoute
  "/session/$id/strength": typeof AppSessionIdStrengthRoute
  "/session/$id/timer": typeof AppSessionIdTimerRoute
  "/session/$id/": typeof AppSessionIdIndexRoute
  "/session/$id/block/$block": typeof AppSessionIdBlockBlockRoute
}
export interface FileRoutesByTo {
  "/first-run": typeof FirstRunRoute
  "/sign-in": typeof SignInRoute
  "/gym": typeof AppGymRoute
  "/settings": typeof AppSettingsRoute
  "/shape": typeof AppShapeRoute
  "/wishes": typeof AppWishesRoute
  "/you": typeof AppYouRoute
  "/": typeof AppIndexRoute
  "/history/$id": typeof AppHistoryIdRoute
  "/movements/$movement": typeof AppMovementsMovementRoute
  "/history": typeof AppHistoryIndexRoute
  "/session/$id/debrief": typeof AppSessionIdDebriefRoute
  "/session/$id/lift": typeof AppSessionIdLiftRoute
  "/session/$id/strength": typeof AppSessionIdStrengthRoute
  "/session/$id/timer": typeof AppSessionIdTimerRoute
  "/session/$id": typeof AppSessionIdIndexRoute
  "/session/$id/block/$block": typeof AppSessionIdBlockBlockRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/first-run": typeof FirstRunRoute
  "/sign-in": typeof SignInRoute
  "/_app/gym": typeof AppGymRoute
  "/_app/settings": typeof AppSettingsRoute
  "/_app/shape": typeof AppShapeRoute
  "/_app/wishes": typeof AppWishesRoute
  "/_app/you": typeof AppYouRoute
  "/_app/": typeof AppIndexRoute
  "/_app/history/$id": typeof AppHistoryIdRoute
  "/_app/movements/$movement": typeof AppMovementsMovementRoute
  "/_app/history/": typeof AppHistoryIndexRoute
  "/_app/session/$id/debrief": typeof AppSessionIdDebriefRoute
  "/_app/session/$id/lift": typeof AppSessionIdLiftRoute
  "/_app/session/$id/strength": typeof AppSessionIdStrengthRoute
  "/_app/session/$id/timer": typeof AppSessionIdTimerRoute
  "/_app/session/$id/": typeof AppSessionIdIndexRoute
  "/_app/session/$id/block/$block": typeof AppSessionIdBlockBlockRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/first-run"
    | "/sign-in"
    | "/gym"
    | "/settings"
    | "/shape"
    | "/wishes"
    | "/you"
    | "/history/$id"
    | "/movements/$movement"
    | "/history/"
    | "/session/$id/debrief"
    | "/session/$id/lift"
    | "/session/$id/strength"
    | "/session/$id/timer"
    | "/session/$id/"
    | "/session/$id/block/$block"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/first-run"
    | "/sign-in"
    | "/gym"
    | "/settings"
    | "/shape"
    | "/wishes"
    | "/you"
    | "/"
    | "/history/$id"
    | "/movements/$movement"
    | "/history"
    | "/session/$id/debrief"
    | "/session/$id/lift"
    | "/session/$id/strength"
    | "/session/$id/timer"
    | "/session/$id"
    | "/session/$id/block/$block"
  id:
    | "__root__"
    | "/_app"
    | "/first-run"
    | "/sign-in"
    | "/_app/gym"
    | "/_app/settings"
    | "/_app/shape"
    | "/_app/wishes"
    | "/_app/you"
    | "/_app/"
    | "/_app/history/$id"
    | "/_app/movements/$movement"
    | "/_app/history/"
    | "/_app/session/$id/debrief"
    | "/_app/session/$id/lift"
    | "/_app/session/$id/strength"
    | "/_app/session/$id/timer"
    | "/_app/session/$id/"
    | "/_app/session/$id/block/$block"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  FirstRunRoute: typeof FirstRunRoute
  SignInRoute: typeof SignInRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/first-run": {
      id: "/first-run"
      path: "/first-run"
      fullPath: "/first-run"
      preLoaderRoute: typeof FirstRunRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sign-in": {
      id: "/sign-in"
      path: "/sign-in"
      fullPath: "/sign-in"
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/gym": {
      id: "/_app/gym"
      path: "/gym"
      fullPath: "/gym"
      preLoaderRoute: typeof AppGymRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/shape": {
      id: "/_app/shape"
      path: "/shape"
      fullPath: "/shape"
      preLoaderRoute: typeof AppShapeRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/wishes": {
      id: "/_app/wishes"
      path: "/wishes"
      fullPath: "/wishes"
      preLoaderRoute: typeof AppWishesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/you": {
      id: "/_app/you"
      path: "/you"
      fullPath: "/you"
      preLoaderRoute: typeof AppYouRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/history/": {
      id: "/_app/history/"
      path: "/history"
      fullPath: "/history/"
      preLoaderRoute: typeof AppHistoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/history/$id": {
      id: "/_app/history/$id"
      path: "/history/$id"
      fullPath: "/history/$id"
      preLoaderRoute: typeof AppHistoryIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/movements/$movement": {
      id: "/_app/movements/$movement"
      path: "/movements/$movement"
      fullPath: "/movements/$movement"
      preLoaderRoute: typeof AppMovementsMovementRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/": {
      id: "/_app/session/$id/"
      path: "/session/$id"
      fullPath: "/session/$id/"
      preLoaderRoute: typeof AppSessionIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/debrief": {
      id: "/_app/session/$id/debrief"
      path: "/session/$id/debrief"
      fullPath: "/session/$id/debrief"
      preLoaderRoute: typeof AppSessionIdDebriefRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/lift": {
      id: "/_app/session/$id/lift"
      path: "/session/$id/lift"
      fullPath: "/session/$id/lift"
      preLoaderRoute: typeof AppSessionIdLiftRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/strength": {
      id: "/_app/session/$id/strength"
      path: "/session/$id/strength"
      fullPath: "/session/$id/strength"
      preLoaderRoute: typeof AppSessionIdStrengthRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/timer": {
      id: "/_app/session/$id/timer"
      path: "/session/$id/timer"
      fullPath: "/session/$id/timer"
      preLoaderRoute: typeof AppSessionIdTimerRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/session/$id/block/$block": {
      id: "/_app/session/$id/block/$block"
      path: "/session/$id/block/$block"
      fullPath: "/session/$id/block/$block"
      preLoaderRoute: typeof AppSessionIdBlockBlockRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppGymRoute: typeof AppGymRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppShapeRoute: typeof AppShapeRoute
  AppWishesRoute: typeof AppWishesRoute
  AppYouRoute: typeof AppYouRoute
  AppIndexRoute: typeof AppIndexRoute
  AppHistoryIdRoute: typeof AppHistoryIdRoute
  AppMovementsMovementRoute: typeof AppMovementsMovementRoute
  AppHistoryIndexRoute: typeof AppHistoryIndexRoute
  AppSessionIdDebriefRoute: typeof AppSessionIdDebriefRoute
  AppSessionIdLiftRoute: typeof AppSessionIdLiftRoute
  AppSessionIdStrengthRoute: typeof AppSessionIdStrengthRoute
  AppSessionIdTimerRoute: typeof AppSessionIdTimerRoute
  AppSessionIdIndexRoute: typeof AppSessionIdIndexRoute
  AppSessionIdBlockBlockRoute: typeof AppSessionIdBlockBlockRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppGymRoute: AppGymRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppShapeRoute: AppShapeRoute,
  AppWishesRoute: AppWishesRoute,
  AppYouRoute: AppYouRoute,
  AppIndexRoute: AppIndexRoute,
  AppHistoryIdRoute: AppHistoryIdRoute,
  AppMovementsMovementRoute: AppMovementsMovementRoute,
  AppHistoryIndexRoute: AppHistoryIndexRoute,
  AppSessionIdDebriefRoute: AppSessionIdDebriefRoute,
  AppSessionIdLiftRoute: AppSessionIdLiftRoute,
  AppSessionIdStrengthRoute: AppSessionIdStrengthRoute,
  AppSessionIdTimerRoute: AppSessionIdTimerRoute,
  AppSessionIdIndexRoute: AppSessionIdIndexRoute,
  AppSessionIdBlockBlockRoute: AppSessionIdBlockBlockRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  FirstRunRoute: FirstRunRoute,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
